exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__inputs___1DcrU{width:400px;margin:40px auto}.style__msg___1gxLq{margin-top:30px;text-align:center}.style__error___2He_f{color:#ff8787}", ""]);

// exports
exports.locals = {
	"inputs": "style__inputs___1DcrU",
	"msg": "style__msg___1gxLq",
	"error": "style__error___2He_f"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/session-modal/style.css
// module id = 707
// module chunks = 0